import { Vector2 } from 'three';

export enum Unit {
  MILLIMETERS = 'mm',
  CENTIMETERS = 'cm',
  METERS = 'm',
  DEGREES = 'degrees',
}

export enum Theme {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export type Size = {
  width: number;
  height: number;
};

export enum WorkspaceMode {
  EDITABLE = 'EDITABLE',
  READONLY = 'READONLY',
  READONLY_SELECTION = 'READONLY_SELECTION',
}

export enum AppMode {
  DigitalTwin = 'DIGITALTWIN',
  FloorplanAdmin = 'FLOORPLAN_ADMIN',
}

export type Result<T> = { status: 'ok'; value: T } | { status: 'error'; error: string };

export type LineSegment = {
  start: Vector2;
  end: Vector2;
};

export type WideLineSegment = {
  points: LineSegment;
  width: number;
};

export type ObjectValues<T> = T[keyof T];

export type SizeShort = {
  w: number;
  h: number;
};
